import {
  type DashRouteType,
  // URL_APP_ADMIN,
  // URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_FULFILLMENT_PARTNER_INTEGRATIONS = `${URL_RETAILER_SCOPED}/fulfillment-partner-integrations`
const URL_FULFILLMENT_PARTNER_INTEGRATIONS_RESPONSE_CONFIGURATIONS_LIST = `${URL_FULFILLMENT_PARTNER_INTEGRATIONS}/response-configurations-list`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'fulfillment-partner-integrations'>
  | DashRouteType<'fulfillment-partner-integrations-response-configurations-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'fulfillment-partner-integrations': URL_FULFILLMENT_PARTNER_INTEGRATIONS,
  'fulfillment-partner-integrations-response-configurations-list':
    URL_FULFILLMENT_PARTNER_INTEGRATIONS_RESPONSE_CONFIGURATIONS_LIST,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
